export default __webpack_public_path__ + "locales/ru/Profile.json?hash=fda32fccbaba459d15661cba0dd0285f";